import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SelectField from '../../elements/form/SelectField'
import ModalActionButton from '../../elements/ModalActionButton'
import { clearUpdatedApplication, updateApplication } from '../../../store/actions/applicationsActions'
import { fetchExaminationCenters } from '../../../store/actions/examinationCentersActions'
import { SET_SUCCESS } from '../../../store/types'

const ChangeExamCenter = ({center, exam, application, schedule, closeFunction, reload}) => {
    const examinationCentersSelector = useSelector(state => state.examinationCenters)
    const applicationsSelector = useSelector(state => state.applications)
    const [examCenter, setExamCenter] = useState(center._id || '');
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchExaminationCenters('', 0, 0))
        if(applicationsSelector.updatedApplication){
            dispatch({
                type: SET_SUCCESS,
                payload: 'examination center changed successfully!'
            })
            dispatch(clearUpdatedApplication())
            reload()
            setTimeout(() => {
                closeFunction()
            }, 50);
        }
            
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicationsSelector.updatedApplication, closeFunction, dispatch]);

    const updateSchedule = () => {
        const updatePayload = {
            schedule: schedule._id,
            center: examCenter
        }

        dispatch(updateApplication(application._id, updatePayload))
    }
    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>You are about to change the examination center for the applicant <span className='font-[550]'>{application.lastName}, {application.firstName} {application.otherNames && application.otherNames?.charAt(0)?.toUpperCase()}</span> for the <span className='font-[550]'>{exam.name}</span></p>
            </div>
            {!examinationCentersSelector?.loadingExaminationCenters && examinationCentersSelector?.examinationCenters?.examinationCenters?.length > 0 && <div className='w-full my-2'>
                <SelectField
                    selectOptions={examinationCentersSelector?.examinationCenters?.examinationCenters}
                    inputLabel="Select examination center"
                    titleField="name"
                    displayImage={false} 
                    imageField=""
                    requiredField={false}
                    preSelectedIndex={examinationCentersSelector?.examinationCenters?.examinationCenters?.findIndex(center => center?._id === examCenter)}
                    fieldId="center-select"
                    hasError={false}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {setExamCenter(value._id)}}
                /> 
            </div>}

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update Exam Center`}
                    buttonAction={()=>{updateSchedule()}}
                    processing={applicationsSelector.updatingApplication}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default ChangeExamCenter